import axios from 'axios';
import type { ProjectUser } from '@/models/projectUser';
import type { Project } from '@/models/project';
import type { XAppliedLesson } from '@/models/xappliedlesson';
import type { XProcess } from '@/models/xprocess';
import type { XSubProcess } from '@/models/xsubprocess';

class XAppliedLessonWebservice {
    public getByWorksheetId(xWorksheetId: number) {
        return axios.get('/xappliedlessons/getByWorksheetId', {
            params: {
                xWorksheetId,
            },
        });
    }

    public update(appliedLesson: XAppliedLesson) {
        return axios.post('/xappliedlessons/update', {
            ...appliedLesson,
        });
    }
    public store(xWorksheetId: number, xAppliedLessons: XAppliedLesson[], xNewAppliedLessons: XAppliedLesson[]) {
        return axios.post('/xappliedlessons/store', {
            xWorksheetId,
            xAppliedLessons,
            xNewAppliedLessons,
        });
    }

    public updateAppliedLessonAndLesson(
        appliedLesson: XAppliedLesson,
        lesson: { insight: string; project_only: boolean; sub_process: XSubProcess }
    ) {
        return axios.post('/xappliedlessons/updateXAppliedLessonAndXLesson', {
            id: appliedLesson.id,
            dynamic_field: appliedLesson.dynamic_field,
            contacttill: appliedLesson.contacttill,
            external_responsible_user: appliedLesson.external_responsible_user,
            internal_responsible_user: appliedLesson.internal_responsible_user,
            responsible_user: appliedLesson.responsible_user,
            todo: appliedLesson.todo,
            solution: appliedLesson.solution,
            lesson: {
                insight: lesson.insight,
                project_only: lesson.project_only,
                sub_process: lesson.sub_process,
            },
        });
    }

    public getToDos() {
        return axios.get('/xappliedlessons/getToDos');
    }

    public getProjectOpenTasks(
        selectedXProcesses: XProcess[],
        selectedResponsibleUsers: ProjectUser[],
        selectedProject: Project
    ) {
        return axios.post('/xappliedlessons/getProjectOpenTasks', {
            x_process_ids: selectedXProcesses.map((el) => el.id),
            responsible_users: selectedResponsibleUsers,
            project_id: selectedProject.id,
        });
    }

    public emailTheOpenTasks(
        selectedXProcesses: XProcess[],
        selectedResponsibleUsers: ProjectUser[],
        selectedProject: Project
    ) {
        return axios.post('/xappliedlessons/emailTheOpenTasks', {
            x_process_ids: selectedXProcesses.map((el) => el.id),
            responsible_users: selectedResponsibleUsers,
            project_id: selectedProject.id,
        });
    }

    public remove(id: number) {
        return axios.delete('/xappliedlessons/remove', {
            params: { id },
        });
    }
}

export const xAppliedLessonWebservice = new XAppliedLessonWebservice();
